<template>
  <div class="row m-0 justify-content-center pt-20 pb-20">
    <div class="col-8">
      <div class="d-flex align-items-center justify-content-center">
        <b-col md="6" cols="12">
          <b-form
            class="auth-login-form p-4 mt-2 text-center"
            @submit.prevent="signin"
          >
            <b-form-input
              v-model="loginData.email"
              name="email"
              type="text"
              placeholder="إسم المستخدم"
            />
            <b-form-input
              v-model="loginData.password"
              name="password"
              type="password"
              placeholder="كلمة المرور"
            />

            <!-- submit button -->
            <b-button
              class="login-btn"
              v-if="!loader"
              variant="primary"
              type="submit"
              block
            >
              <span>تسجيل دخول</span>
            </b-button>
            <b-button
              class="login-btn"
              v-if="loader"
              variant="primary"
              disabled
              block
            >
              <b-spinner small type="grow" />
              برجاء الانتظار...
            </b-button>
          </b-form>
          <div v-if="loginError" class="text-danger mt-2">
            {{ loginError }}
          </div>
        </b-col>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "LoginPage",
  components: {},
  data() {
    return {
      status: "",
      loginData: {
        password: "",
        email: "",
      },
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    ...mapState(["loginMinistry/loader", "loginMinistry/loginError"]),
  },
  mounted() {
    if (
      localStorage.getItem("token") !== null &&
      this.$route.path === "/login"
    ) {
      this.$router.push("/company"); // redirect to home
    }
  },
  methods: {
    signin() {
      this.loader = true;
      this.error = ""; // Reset error message on each login attempt
      this.$store.dispatch("loginMinistry/login", this.loginData);
    },
  },
};
</script>
